import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent, ConfigurationService, ConfirmComponent, LoggerService, SecurityService } from 'saker-core';
import { NoteDTO } from 'src/app/Protocol/note.dto';
import { ProjectDTO } from 'src/app/Protocol/project.dto';
import { ProjectScenarioDTO } from 'src/app/Protocol/projectScenario.dto';
import { ProjectScenarioPageDTO } from 'src/app/Protocol/projectScenarioPage.dto';
import { ProjectScenarioService } from 'src/app/Service/project-scenario.service';
import { ProjectService } from 'src/app/Service/project.service';

@Component({
  selector: 'app-project-scenario',
  templateUrl: './project-scenario.component.html',
  styleUrls: ['./project-scenario.component.css']
})
export class ProjectScenarioComponent extends BaseComponent implements OnInit {

  //-------------------------------
  // Model
  //-------------------------------

  project: ProjectDTO | null = null;
  data: ProjectScenarioDTO | null = null;

  id: string = '';

  isShowDeleted = false

  //-------------------------------
  // Behaviour
  //-------------------------------

  showScenarioList() {
    if (this.project)
      this.router.navigate(["projectScenarios/" + this.project.mnemonic])
  }

  deleteScenario() {
    if (this.project && this.data)
      return this.projectScenarioService.deleteProjectScenario(this.project.mnemonic, this.data.projectScenarioId.toString())
        .subscribe(() => { this.refreshData() });
    else
      return
  }

  exportScenario() {


    let modalConfig = {
      "animation": true,
      "backdrop": false,
      "component": "editPersonalCarbonCalculator",
      "size": "md",
    };

    let modalInstance = this.modalService.open(ConfirmComponent, modalConfig);

    modalInstance.result.then((result) => {
      console.log("result")
      console.log(result)
      if (result){
        if (this.project && this.data){
          console.log("here")
          this.projectScenarioService.getProjectScenarioCSV(this.project.mnemonic, this.data.projectScenarioId.toString()).subscribe(()=>{}); //this.data.exportedScenarioId);
        }
      }
    })
  }

  showNotes(item: NoteDTO) {
    if (this.data)
      this.router.navigate(['note/' + this.data.projectScenarioId + '/' + item.noteId])
    // $location.path("dsm/note/" + this.data.projectScenarioId + '/' + item.noteId);
  }

  createNote() {
    if (this.data)
      this.router.navigate(['note/' + this.data.projectScenarioId + '/0'])
    // $location.path("dsm/note/" + this.data.projectScenarioId + '/0');
  }

  //-------------------------------
  // Private
  //-------------------------------

  private storeProject(data: ProjectDTO) {
    this.project = data;
  }

  private refreshProject(mnemonic: string) {

    return this.projectService.getProject(mnemonic)
      .subscribe((data) => { this.storeProject(data) })

  }

  private storeProjectScenario(data: ProjectScenarioDTO) {
    this.data = data;
    this.refreshProject(this.data.mnemonic);
  }

  private refreshData() {
    return this.projectScenarioService.getProjectScenario(this.id)
      .subscribe((data) => { this.storeProjectScenario(data) })
  }

  //-------------------------------
  // Form
  //-------------------------------

  //-------------------------------
  // System
  //-------------------------------

  private activate() {

    this.activatedRoute.paramMap.subscribe((params: any) => {
      this.id = params.params.id
    });

    this.refreshData();
  }

  constructor(
    security: SecurityService,
    configuration: ConfigurationService,
    logger: LoggerService,
    router: Router,
    modal: NgbModal,
    changeDetectorRef: ChangeDetectorRef,
    private projectScenarioService: ProjectScenarioService,
    private projectService: ProjectService,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal
  ) {
    super(security, configuration, logger, router, modal, changeDetectorRef);
  }

  ngOnInit(): void {
    this.activate()
  }

}
